<template>
  <RevInfoBlock
    :content="i18n(translations.lrrInfoBlockContent)"
    data-test="lrr-info-block"
    :icon="IconClock"
    :title="i18n(translations.lrrInfoBlockTitle)"
    variant="info"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconClock } from '@ds/icons/IconClock'

import translations from './LrrInfoBlock.translations'

const i18n = useI18n()
</script>
